import React from "react";
import {NearbyUsersModel} from "@/app/api/user";
import styles from "../styles.module.scss";
import Button from "@/app/components/button";
import {s} from "@/app/utils/s";
import {t} from "i18next";
import DetailPlayerCard from "src/app/components/detail_player_card";

interface DetailPlayerPageDesktopViewProps {
  user: NearbyUsersModel;
  hasLoading: boolean;
  createChat: (userId: number) => void;
  goToCreateAMatch: (user: NearbyUsersModel) => void;
}

/**
 * Desktop view for the DetailPlayerPage
 */
const DetailPlayerPageDesktopView: React.FC<DetailPlayerPageDesktopViewProps> = ({
  user,
  hasLoading,
  createChat,
  goToCreateAMatch
}) => {
  return (
    <div className={styles.detailPlayerPageDesktop}>
      <div className={styles.container}>
        <div className={styles.cardWrapper}>
          <DetailPlayerCard user={user}/>
        </div>
        <div className={styles.buttonsDesktop}>
          <Button 
            text={t(s.chat)} 
            onClick={() => createChat(user.id)} 
            isViolet 
            isLoading={hasLoading}
          />
          <Button 
            text={t(s.createAMatch)} 
            onClick={() => goToCreateAMatch(user)}
          />
        </div>
      </div>
    </div>
  );
};

export default DetailPlayerPageDesktopView;